import { makeStyles } from "@material-ui/core";

export const kpiDashboardStyles = makeStyles((theme) => ({
    tabs: {
        padding: '2em 0',
    },
}));